const xafFormatter = new Intl.NumberFormat("fr-FR", {
  style: "currency",
  currency: "XAF",
  maximumFractionDigits: 0,
});

// Prices are defined and charged in FCFA (XAF)
export const formatPrice = (price) => xafFormatter.format(Number(price) || 0);
